import type { CSSProperties, ReactNode } from 'react';

export const categoryDescriptionStyle: CSSProperties = {
  fontSize: '14px',
  margin: '8px 0px',
};

const Subtitle = ({ children }: { children?: ReactNode }) => {
  return (
    <p
      className="blox-subtitle"
      style={categoryDescriptionStyle}
    >
      {children}
    </p>
  );
};

export default Subtitle;
